import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
    createLineConfigData,
    getLineConfigData,
    updateLineConfigData
} from '../../../data/LineConfig/repositories/LineConfig.repository';
import { LineConfig } from '../../../data/LineConfig/schemas/LineConfig.schema';

const emptyForm = (): LineConfig => ({
    sid: '',
    wfcondition: '',
    contentbody: '',
    wftype: ''
});

function LineConfigViewModel() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [lineConfigs, setLineConfigs] = useState<LineConfig[]>();

    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [editForm, setEditForm] = useState<LineConfig>(emptyForm());

    const [showCreateForm, setShowCreateForm] = useState<boolean>(false);
    const [createForm, setCreateForm] = useState<LineConfig>(emptyForm());

    useEffect(() => {
        fetchLineConfig();
    }, []);

    const withLoader = async (fn: () => Promise<void>) => {
        setIsLoading(true);
        const element = document.getElementsByClassName('Loader__background');
        try {
            if (element.length > 0) element[0].className = 'Loader__background show';
            await fn();
        } catch (error) {
            if (!error) return;
            if (error instanceof AxiosError) {
                Swal.fire('Error', error.response?.data.message || 'ไม่ทราบสาเหตุ');
            } else if (error instanceof Error) {
                Swal.fire('Error', error.message);
            }
        } finally {
            setIsLoading(false);
            if (element.length > 0) element[0].className = 'Loader__background hide';
        }
    };

    const fetchLineConfig = () =>
        withLoader(async () => {
            const [, response] = await getLineConfigData();
            setLineConfigs(response.result_list);
        });

    const handleStartEdit = (index: number) => {
        const item = lineConfigs![index];
        setEditingIndex(index);
        setEditForm({ ...item });
    };

    const handleCancelEdit = () => {
        setEditingIndex(null);
        setEditForm(emptyForm());
    };

    const handleSaveEdit = () =>
        withLoader(async () => {
            await updateLineConfigData(editForm);
            setEditingIndex(null);
            setEditForm(emptyForm());
            const [, response] = await getLineConfigData();
            setLineConfigs(response.result_list);
            Swal.fire('Success', 'บันทึกสำเร็จ', 'success');
        });

    const handleOpenCreate = () => {
        setCreateForm(emptyForm());
        setShowCreateForm(true);
    };

    const handleCancelCreate = () => {
        setShowCreateForm(false);
        setCreateForm(emptyForm());
    };

    const handleSaveCreate = () =>
        withLoader(async () => {
            await createLineConfigData(createForm);
            setShowCreateForm(false);
            setCreateForm(emptyForm());
            const [, response] = await getLineConfigData();
            setLineConfigs(response.result_list);
            Swal.fire('Success', 'สร้างสำเร็จ', 'success');
        });

    return {
        isLoading,
        lineConfigs,
        editingIndex,
        editForm,
        setEditForm,
        handleStartEdit,
        handleCancelEdit,
        handleSaveEdit,
        showCreateForm,
        createForm,
        setCreateForm,
        handleOpenCreate,
        handleCancelCreate,
        handleSaveCreate
    };
}

export default LineConfigViewModel;
